module.exports = __webpack_public_path__ + "images/level_fourth.21a518e0389b4ed3b9c3c742c3f191b1.png";